import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getPublicListingById } from "../../api/classicSiteHoodieApi";
import { formatClassicSiteError } from "../../classicSite.utils";
import { CLASSIC_SITE_BASE } from "../../classicSite.constants";

export default function PublicListingDetailPage() {
  const { id } = useParams();
  const [state, setState] = useState({ loading: true, error: null, listing: null });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, error: null, listing: null });
    getPublicListingById(id)
      .then((listing) => {
        if (!cancelled) setState({ loading: false, error: null, listing });
      })
      .catch((err) => {
        if (!cancelled) {
          setState({
            loading: false,
            error: formatClassicSiteError(err),
            listing: null,
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (state.loading) return <p>Loading listing…</p>;
  if (state.error) return <p className="cs-panel__error">{state.error}</p>;
  if (!state.listing) return <p>Listing not found.</p>;

  const listing = state.listing;

  return (
    <article className="cs-detail">
      <p>
        <Link to={`${CLASSIC_SITE_BASE}/public/listings`}>← All listings</Link>
      </p>
      <h1>{listing.business_name}</h1>
      <dl className="cs-detail__dl">
        <dt>Contact</dt>
        <dd>
          {listing.contact_name}
          {listing.contact_title ? ` — ${listing.contact_title}` : ""}
        </dd>
        <dt>Email</dt>
        <dd>{listing.email || "—"}</dd>
        <dt>Website</dt>
        <dd>
          {listing.website ? (
            <a href={listing.website} target="_blank" rel="noopener noreferrer">
              {listing.website}
            </a>
          ) : (
            "—"
          )}
        </dd>
        <dt>Short description</dt>
        <dd>{listing.short_description || "—"}</dd>
        <dt>Extended description</dt>
        <dd>{listing.extended_description || "—"}</dd>
      </dl>
    </article>
  );
}
